export const GUIDE_PREFIX = "/reweb";
export const GUIDE_APPLICATION_ID = "reweb-guide-fixtures";
export const CMS_PREVIEW_APPLICATION_ID = "reweb-cms-preview";
export const isCmsPreviewApplication = (id: string | null | undefined) =>
  id === CMS_PREVIEW_APPLICATION_ID;
export const isGuideApplication = (id: string | null | undefined) =>
  id === GUIDE_APPLICATION_ID || isCmsPreviewApplication(id);

export const isGuideHost = (host: string) =>
  /^guide\.homepage(?:-vnext)?\.(int|prod)\.realequity\.dk$/.test(
    host.toLowerCase().split(":")[0],
  );
